import React from 'react';
import { Link } from 'react-router-dom';

function Partnerships() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-emerald-700 to-blue-700 text-white py-16">
        <div className="container mx-auto px-4 max-w-5xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Partner With Us</h1>
          <p className="text-lg text-emerald-50">
            Collaborate with AdverseVideo Detector AI on research, safety, and institutional adoption.
          </p>
        </div>
      </div>

      <main className="container mx-auto px-4 py-12 max-w-5xl space-y-8">
        <section className="bg-white rounded-xl shadow p-8">
          <h2 className="text-2xl font-bold mb-4">Institutional Partnerships</h2>
          <p className="text-gray-700 mb-4">We&apos;re actively seeking partnerships with:</p>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><strong>Universities:</strong> Research collaborations, student access</li>
            <li><strong>K-12 Schools:</strong> Student safety, curriculum vetting</li>
            <li><strong>Training Organizations:</strong> Content validation, compliance</li>
            <li><strong>Security Firms:</strong> Integration opportunities</li>
            <li><strong>Government Agencies:</strong> Threat intelligence support</li>
          </ul>

          <h3 className="text-xl font-semibold mt-8 mb-3">Benefits for Partners</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Free or discounted access</li>
            <li>Priority support</li>
            <li>Custom features and integrations</li>
            <li>Co-publication opportunities</li>
            <li>Featured case studies</li>
          </ul>
        </section>

        <section className="bg-white rounded-xl shadow p-8">
          <h2 className="text-2xl font-bold mb-4">Academic Collaboration</h2>
          <p className="text-gray-700 mb-4">Interested in research collaboration?</p>

          <h3 className="text-xl font-semibold mb-3">We can provide:</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
            <li>Access to our platform and APIs</li>
            <li>Labeled datasets for validation</li>
            <li>Technical consultation</li>
            <li>Co-authorship opportunities</li>
          </ul>

          <h3 className="text-xl font-semibold mb-3">We&apos;re interested in:</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Model improvement research</li>
            <li>Cross-platform expansion studies</li>
            <li>Threat taxonomy development</li>
            <li>Adversarial robustness research</li>
          </ul>
        </section>

        <section className="bg-white rounded-xl shadow p-8">
          <h2 className="text-2xl font-bold mb-4">Press &amp; Media</h2>
          <p className="text-gray-700">Media inquiries: press@adversevideo.org</p>
        </section>

        <section className="bg-white rounded-xl shadow p-8">
          <h2 className="text-2xl font-bold mb-4">General Contact</h2>
          <p className="text-gray-700"><strong>Email:</strong> contact@adversevideo.org</p>
          <p className="text-gray-700"><strong>Response Time:</strong> Within 24 hours</p>
        </section>

        <section className="bg-emerald-50 border border-emerald-200 rounded-xl p-8">
          <h2 className="text-2xl font-bold mb-4">Request a Demo</h2>
          <p className="text-gray-700 mb-4">Interested in a live demonstration for your organization?</p>
          <p className="text-gray-700"><strong>Email:</strong> contact@adversevideo.org</p>
          <div className="mt-6 space-x-3">
            <Link
              to="/"
              className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              Back to Home
            </Link>
            <Link
              to="/faq"
              className="inline-block bg-slate-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-slate-800 transition"
            >
              FAQ
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Partnerships;
